import Vue from 'vue'

const auth = ({
    state: {
        user: {
            id: '',
            name: '',
            role: '',
            email: ''
        },
        token: {
            value: '',
            type: '',
            expire_at: ''
        },
        authenticated:  false,
        permissions: [],
        notificationCounter: 0,
        notificationData: []
    },
    mutations: {
        SET_AUTH_USER: (state, data) => {
            state.user = data;
        },
        SET_TOKEN: (state, data) => {
            state.token = data;
        },
        SET_AUTH: (state, data) => {
            state.authenticated = data;
        },
        initialiseStore(state) {
            if (Vue.$cookies.isKey('token')) {
                state.authenticated = true;
                state.token.value = Vue.$cookies.get('token');
                state.token.type  = 'Bearer';
                state.user        = Vue.$cookies.get("user");
            }
        },
      SET_PERMISSIONS: (state, data) => {
        state.permissions = data;
      },
      SET_NOTIFICATION_COUNT: (state, data) => {
        state.notificationCounter = data;
      },
      SET_NOTIFICATION_DATA: (state, data) => {
        state.notificationData = data;
      },
    },
    actions: {
        SET_AUTH_USER: ({commit}, data) => {
            commit('SET_AUTH_USER', data);
        },
        SET_TOKEN: ({commit}, data) => {
            commit('SET_TOKEN', data);
        },
        SET_AUTH: ({commit}, data) => {
        commit('SET_AUTH', data);
        },
        SET_PERMISSIONS: ({commit}, data) => {
         commit('SET_PERMISSIONS', data);
        },
        SET_NOTIFICATION_COUNT: ({commit}, data) => {
            commit('SET_NOTIFICATION_COUNT', data);
        },
        SET_NOTIFICATION_DATA: ({commit}, data) => {
            commit('SET_NOTIFICATION_DATA', data);
        }
    },
    getters: {
        SET_AUTH_USER: state => state.user,
        SET_TOKEN: state => state.token,
        SET_AUTH: state => state.authenticated,
        GET_PERMISSIONS: state => state.permissions,
        GET_NOTIFICATION_COUNT: state => state.notificationCounter,
        GET_NOTIFICATION_DATA: state => state.notificationData,
    }
});

export default auth;
